import React from "react";
import "./procedure.css";

const Procedure = () => {
  const procedures = [
    {
      name: "1-7 ALIGNERS (DUAL ARCH)",
      department: "ALIGNERS",
      schedule: "5",
      sort: "1"
    },
    {
      name: "1-7 ALIGNERS (SINGLE ARCH)",
      department: "ALIGNERS",
      schedule: "",
      sort: "1"
    },
    {
      name: "3D PRINTED MODELS",
      department: "Stackable Stent",
      schedule: "",
      sort: "1"
    },
    {
      name: "3D PRINTED STUDY MODELS",
      department: "STUDY MODELS",
      schedule: "5",
      sort: "1"
    },
    {
      name: "ACRYLIC DENTURE WITH IMPLANT ATTACHMENT (2 LOCATORS)",
      department: "IMPLANTS",
      schedule: "",
      sort: "1"
    },
    {
      name: "ANKYLOS ND Sleeves - 4.48mm",
      department: "",
      schedule: "",
      sort: "1"
    },
  ];

  return (
    <div
      className="procedure-container"
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif"
      }}
    >

      {/* Title */}
      <h2
        className="procedure-title"
        style={{
          color: "#004aad",
          paddingBottom: "3px"
        }}
      >
        Procedures
      </h2>


      {/* Table */}
      <table
        className="procedure-table"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "10px"
        }}
      >

        <thead>
          <tr
            style={{
              backgroundColor: "#f4f4f4",
              textAlign: "left"
            }}
          >

            <th
              className="procedure-header procedure-name"
              style={headerStyle}
            >
              Name
            </th>

            <th
              className="procedure-header procedure-department"
              style={headerStyle}
            >
              Department
            </th>

            <th
              className="procedure-header procedure-schedule"
              style={headerStyle}
            >
              Schedule
            </th>

            <th
              className="procedure-header procedure-sort"
              style={headerStyle}
            >
              Sort
            </th>

          </tr>
        </thead>


        <tbody>

          {procedures.map((item, index) => (

            <tr
              key={index}
              style={{
                borderBottom: "1px solid #ccc"
              }}
            >

              {/* Name */}
              <td
                className="procedure-cell procedure-name"
                style={cellStyle}
              >
                {item.name}
              </td>


              {/* Department */}
              <td
                className="procedure-cell procedure-department"
                style={cellStyle}
              >
                {item.department}
              </td>


              {/* Schedule */}
              <td
                className="procedure-cell procedure-schedule"
                style={cellStyle}
              >
                {item.schedule}
              </td>


              {/* Sort */}
              <td
                className="procedure-cell procedure-sort"
                style={cellStyle}
              >
                {item.sort}
              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
};


// Desktop styling - unchanged
const headerStyle = {
  padding: "10px",
  borderTop: "3px solid #004aad",
  fontWeight: "bold",
};


// Desktop styling - unchanged
const cellStyle = {
  padding: "10px",
};


export default Procedure;